// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__fAlfE","actions":"GroupTable_actions__XVlaA","deleteModalFooter":"GroupTable_deleteModalFooter__1PK3K"};